import React from 'react';
import './TimeOverlay.css';

interface TimeOverlayProps {
  delayedTime?: Date;
}

const TimeOverlay: React.FC<TimeOverlayProps> = ({ delayedTime }) => {
  if (!delayedTime) return null;

  const formattedTime = `${delayedTime.toISOString().substring(0, 10)} ${delayedTime.toISOString().substring(11, 19)}`;

  return (
    <div className="time-overlay">
      <div className="time-overlay-content">
        <span className="time-overlay-value">{formattedTime}</span>
        <span className="time-overlay-label">UTC</span>
        <span className="time-overlay-delay">60s delay</span>
      </div>
    </div>
  );
};

export default TimeOverlay;